module.exports = __webpack_public_path__ + "static/media/slogan.ecde55c2.png";